package one.healthium.rateus.data

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import one.healthium.base.preferences.AppPreferences
import one.healthium.rateus.ui.RateUsDialog
import one.primehealth.app.BaseAppConfig
import org.koin.compose.koinInject

enum class RATE_STATUS {
    DO_NOT_RATE,
    SHOULD_RATE,
    UNDEFINED
}

class AppRateManager(
    private val appPreferences: AppPreferences,
    private val baseAppConfig: BaseAppConfig,
) {
    fun homeVisitCounter(): Boolean {
        if (!baseAppConfig.features.rateAppEnabled()) {
            return false
        }

        if (appPreferences.didRateApp || appPreferences.didTriggerStartPopup) {
            return false
        }
        val homeTaps = appPreferences.appVisitCounter
        var res = false
        if (homeTaps >= 7) {
            appPreferences.didTriggerStartPopup = true
            res = true
        }
        return res
    }

    fun foodLogCounter(): RATE_STATUS {
        if (!baseAppConfig.features.rateAppEnabled()) {
            return RATE_STATUS.DO_NOT_RATE
        }

        if (appPreferences.didRateApp) {
            return RATE_STATUS.DO_NOT_RATE
        }
        var foodLogs = appPreferences.foodLogCount
        foodLogs += 1
        appPreferences.foodLogCount = foodLogs

        return if (foodLogs == 7) RATE_STATUS.SHOULD_RATE else RATE_STATUS.DO_NOT_RATE
    }

    fun weightLossWatcher(delta: Float): RATE_STATUS {
        if (!baseAppConfig.features.rateAppEnabled()) {
            return RATE_STATUS.DO_NOT_RATE
        }

        if (appPreferences.didRateApp || delta < 0.4 || appPreferences.didTriggerWeightRatePopup) {
            return RATE_STATUS.DO_NOT_RATE
        }

        appPreferences.didTriggerWeightRatePopup = true
        return RATE_STATUS.SHOULD_RATE
    }
}

@Composable
fun ShowAppRateForWeightLoss(delta: Float, onDismissRequest: () -> Unit) {
    val appRateManager = koinInject<AppRateManager>()
    var shouldRateApp by remember { mutableStateOf(RATE_STATUS.UNDEFINED) }

    LaunchedEffect(Unit) {
        shouldRateApp = appRateManager.weightLossWatcher(delta)
    }

    if (shouldRateApp == RATE_STATUS.SHOULD_RATE) {
        RateUsDialog(onDismissRequest = {
            shouldRateApp = RATE_STATUS.DO_NOT_RATE
            onDismissRequest()
        })
    }

    if (shouldRateApp == RATE_STATUS.DO_NOT_RATE) {
        onDismissRequest()
    }
}

@Composable
fun ShowAppRateForFoodLog(onDismissRequest: () -> Unit) {
    val appRateManager = koinInject<AppRateManager>()
    var shouldRateApp by remember { mutableStateOf(RATE_STATUS.UNDEFINED) }

    LaunchedEffect(Unit) {
        shouldRateApp = appRateManager.foodLogCounter()
    }

    if (shouldRateApp == RATE_STATUS.SHOULD_RATE) {
        RateUsDialog(onDismissRequest = {
            shouldRateApp = RATE_STATUS.SHOULD_RATE
            onDismissRequest()
        })
    }
    if (shouldRateApp == RATE_STATUS.DO_NOT_RATE) {
        onDismissRequest()
    }
}

@Composable
fun ShowAppRateForStart() {
    val appRateManager = koinInject<AppRateManager>()
    var shouldRateApp by remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
        shouldRateApp = appRateManager.homeVisitCounter()
    }

    if (shouldRateApp) {
        RateUsDialog(onDismissRequest = { shouldRateApp = false })
    }
}